export default __webpack_public_path__ + "static/media/0xa3fa99a148fa48d14ed51d610c367c61876997f1.1ccf3be7.png";